import React from "react";

const IdentificationSettingIcon = ({ className = "", width = 64, height = 64, ...props }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.7185 9.2363C40.1924 8.11917 43.0178 8.11914 45.4916 9.2363C48.3279 10.5171 50.4998 14.3344 54.8447 21.9674C59.1895 29.6004 61.3624 33.4172 61.0378 36.5489C60.7546 39.2804 59.342 41.7616 57.1513 43.3759C54.6395 45.2268 50.2948 45.2275 41.6051 45.2275C32.9155 45.2275 28.5707 45.2268 26.0589 43.3759C23.8682 41.7616 22.4555 39.2804 22.1723 36.5489C21.8478 33.4172 24.0206 29.6005 28.3655 21.9674C32.7104 14.3344 34.8823 10.5171 37.7185 9.2363ZM41.4043 32.7228C40.7327 32.7229 40.1525 32.9668 39.6641 33.4553C39.1961 33.9234 38.9618 34.4935 38.9618 35.1652C38.9618 35.8368 39.1962 36.4168 39.6641 36.9053C40.1525 37.3734 40.7327 37.6075 41.4043 37.6076C42.076 37.6076 42.646 37.3735 43.1142 36.9053C43.6027 36.4168 43.8478 35.8369 43.8479 35.1652C43.8479 34.4934 43.6027 33.9235 43.1142 33.4553C42.646 32.9668 42.0759 32.7228 41.4043 32.7228ZM41.4043 15.7754C40.1805 15.7757 39.1952 16.7795 39.2184 18.0031L39.4134 28.2337C39.4341 29.3186 40.3193 30.1872 41.4043 30.1874C42.4895 30.1874 43.3756 29.3187 43.3963 28.2337L43.5913 18.0031C43.6145 16.7794 42.6282 15.7754 41.4043 15.7754Z"
        fill="#B3B4B6"
      />

      <foreignObject x="-9.32656" y="0.3281" width="68.9969" height="69.0038">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(5.3px)",
            clipPath: "url(#bgblur_0_4060_115444_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <path
        data-figma-bg-blur-radius="10.6"
        d="M21.0381 11.6279C26.3472 11.6279 30.8699 13.4789 34.5625 17.1719C38.2549 20.8648 40.1055 25.3877 40.1055 30.6973C40.1054 32.9143 39.7585 35.0127 39.0615 36.9873C38.4373 38.7557 37.5774 40.3877 36.4844 41.8828L47.4766 52.876C48.0629 53.4624 48.37 54.1846 48.3701 55.0078C48.3701 55.7284 48.1348 56.3716 47.6826 56.9131L47.4756 57.1387C46.8898 57.7226 46.1695 58.0302 45.3486 58.0322C44.525 58.0342 43.8023 57.7253 43.2148 57.1377L32.2227 46.1445C30.7268 47.2365 29.0948 48.097 27.3281 48.7227C25.478 49.3778 23.518 49.7225 21.4521 49.7617L21.0381 49.7656C15.7292 49.7655 11.2071 47.9155 7.51465 44.2227C3.82216 40.5297 1.97174 36.0068 1.97168 30.6973C1.97168 25.3877 3.82219 20.8648 7.51465 17.1719C11.2071 13.479 15.7292 11.628 21.0381 11.6279Z"
        fill="#B3B4B6"
        fillOpacity="0.05"
        stroke="url(#paint0_linear_4060_115444)"
        strokeWidth="1.4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />

      <foreignObject x="-5.17969" y="7.38281" width="53.5469" height="48.3113">
        <div
          xmlns="http://www.w3.org/1999/xhtml"
          style={{
            backdropFilter: "blur(8.25px)",
            clipPath: "url(#bgblur_1_4060_115444_clip_path)",
            height: "100%",
            width: "100%",
          }}
        />
      </foreignObject>

      <g filter="url(#filter1_d_4060_115444)" data-figma-bg-blur-radius="16.5">
        <path
          d="M19.0058 33.2533L15.5151 29.8236C15.0252 29.3336 14.4537 29.0886 13.8004 29.0886C13.1472 29.0886 12.5756 29.3336 12.0857 29.8236C11.5958 30.3136 11.341 30.8852 11.3214 31.5385C11.3019 32.1917 11.5362 32.7634 12.0245 33.2533L17.2299 38.4591C17.7198 38.9491 18.302 39.1941 18.9764 39.1941C19.6509 39.1941 20.2322 38.9491 20.7205 38.4591L31.1313 28.1087C31.6212 27.6188 31.8661 27.0365 31.8661 26.362C31.8661 25.6875 31.6212 25.1061 31.1313 24.6178C30.6413 24.1294 30.06 23.8845 29.3872 23.8828C28.7143 23.8812 28.1322 24.1262 27.6406 24.6178L19.0058 33.2533Z"
          fill="url(#paint1_linear_4060_115444)"
        />
      </g>

      <defs>
        <clipPath id="bgblur_0_4060_115444_clip_path" transform="translate(9.32656 -0.3281)">
          <path d="M21.0381 11.6279C26.3472 11.6279 30.8699 13.4789 34.5625 17.1719C38.2549 20.8648 40.1055 25.3877 40.1055 30.6973C40.1054 32.9143 39.7585 35.0127 39.0615 36.9873C38.4373 38.7557 37.5774 40.3877 36.4844 41.8828L47.4766 52.876C48.0629 53.4624 48.37 54.1846 48.3701 55.0078C48.3701 55.7284 48.1348 56.3716 47.6826 56.9131L47.4756 57.1387C46.8898 57.7226 46.1695 58.0302 45.3486 58.0322C44.525 58.0342 43.8023 57.7253 43.2148 57.1377L32.2227 46.1445C30.7268 47.2365 29.0948 48.097 27.3281 48.7227C25.478 49.3778 23.518 49.7225 21.4521 49.7617L21.0381 49.7656C15.7292 49.7655 11.2071 47.9155 7.51465 44.2227C3.82216 40.5297 1.97174 36.0068 1.97168 30.6973C1.97168 25.3877 3.82219 20.8648 7.51465 17.1719C11.2071 13.479 15.7292 11.628 21.0381 11.6279Z" />
        </clipPath>

        <filter
          id="filter1_d_4060_115444"
          x="-5.17969"
          y="7.38281"
          width="53.5469"
          height="48.3113"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            type="matrix"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dy="1" />
          <feGaussianBlur stdDeviation="3.50204" />
          <feColorMatrix
            type="matrix"
            values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.27 0"
          />
          <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_4060_115444" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_4060_115444" result="shape" />
        </filter>

        <clipPath id="bgblur_1_4060_115444_clip_path" transform="translate(5.17969 -7.38281)">
          <path d="M19.0058 33.2533L15.5151 29.8236C15.0252 29.3336 14.4537 29.0886 13.8004 29.0886C13.1472 29.0886 12.5756 29.3336 12.0857 29.8236C11.5958 30.3136 11.341 30.8852 11.3214 31.5385C11.3019 32.1917 11.5362 32.7634 12.0245 33.2533L17.2299 38.4591C17.7198 38.9491 18.302 39.1941 18.9764 39.1941C19.6509 39.1941 20.2322 38.9491 20.7205 38.4591L31.1313 28.1087C31.6212 27.6188 31.8661 27.0365 31.8661 26.362C31.8661 25.6875 31.6212 25.1061 31.1313 24.6178C30.6413 24.1294 30.06 23.8845 29.3872 23.8828C28.7143 23.8812 28.1322 24.1262 27.6406 24.6178L19.0058 33.2533Z" />
        </clipPath>

        <linearGradient
          id="paint0_linear_4060_115444"
          x1="17.8109"
          y1="23.8095"
          x2="56.2651"
          y2="65.3822"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="white" stopOpacity="0.35" />
          <stop offset="1" stopColor="white" stopOpacity="0" />
        </linearGradient>

        <linearGradient
          id="paint1_linear_4060_115444"
          x1="11.3203"
          y1="23.8828"
          x2="30.8685"
          y2="22.589"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#ABABAB" />
          <stop offset="1" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default IdentificationSettingIcon;
